export default "__VITE_ASSET__B512$45E__"